import { useState } from 'react';
import { IssueDocumentDataProviderProps } from './issue-document-form-data-provider.types';
import { useCreateIssueDocumentFormSchema } from '../hooks/use-create-issue-document-form-schema';
import { IssueDocumentFormContent } from '../issue-document-form-content/issue-document-form-content';

export const IssueDocumentDataProvider = ({
  documentModelsResponse,
}: IssueDocumentDataProviderProps) => {
  const [selectedDocumentType, setSelectedDocumentType] = useState<string>('');
  const formSchema = useCreateIssueDocumentFormSchema(documentModelsResponse, selectedDocumentType);
  const availableDocuments = Object.keys(documentModelsResponse).map((key) => {
    return {
      value: key,
      label: documentModelsResponse[key].copy,
    };
  });

  return (
    <IssueDocumentFormContent
      key={selectedDocumentType}
      selectedDocumentType={selectedDocumentType}
      availableDocuments={availableDocuments}
      availableLanguages={documentModelsResponse[selectedDocumentType]?.availableLanguages || []}
      formSchema={formSchema}
      selectedDocumentModel={documentModelsResponse[selectedDocumentType]}
      onDocumentTypeChange={(docType) => setSelectedDocumentType(docType)}
    />
  );
};
